module.exports = __webpack_public_path__ + "static/media/AVK01955.2f55fd50.jpg";